'use client'

import { useEffect, useRef } from 'react'
import {
  HAWAII_HERO_POSTER,
  HAWAII_HERO_VIDEO_SRC,
} from '../themeClasses'

export const Header = () => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    video.muted = true
    video.defaultMuted = true
    video.setAttribute('muted', '')
    video.setAttribute('playsinline', '')
    video.setAttribute('webkit-playsinline', '')

    const tryPlay = () => {
      const p = video.play()
      if (p !== undefined) {
        p.catch(() => {
          /* autoplay blocked — poster remains */
        })
      }
    }

    if (video.readyState >= 2) tryPlay()
    else video.addEventListener('loadeddata', tryPlay, { once: true })

    const onVisibility = () => {
      if (document.hidden) {
        try {
          video.pause()
        } catch {
          /* ignore */
        }
      } else {
        tryPlay()
      }
    }

    document.addEventListener('visibilitychange', onVisibility)
    return () => document.removeEventListener('visibilitychange', onVisibility)
  }, [])

  return (
    <div className="relative min-h-[240px] bg-black md:min-h-[320px] lg:min-h-[420px]">
      <div className="absolute inset-0 overflow-hidden">
        <video
          ref={videoRef}
          className="absolute inset-0 hidden h-full w-full object-cover object-center md:block [filter:saturate(1.15)_brightness(1.05)]"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster={HAWAII_HERO_POSTER}
          aria-label="Oceanfront masthead video of Grand Hyatt Kauai"
        >
          <source src={HAWAII_HERO_VIDEO_SRC} type="video/mp4" />
        </video>

        <img
          src={HAWAII_HERO_POSTER}
          alt=""
          className="absolute inset-0 h-full w-full object-cover object-center md:hidden"
          aria-hidden
        />

        <div
          className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_top,rgba(0,0,0,0.38),transparent_70%)]"
          aria-hidden
        />
      </div>

      <div className="relative z-10 mx-auto flex min-h-[240px] max-w-(--breakpoint-xl) flex-col md:min-h-[320px] lg:min-h-[420px]">
        <div className="flex flex-1 flex-col justify-center px-4 pb-10 pt-4 md:pb-14">
          <div className="mx-auto mt-6 w-11/12 max-w-lg md:mt-10 lg:mt-14">
            <img
              src="https://vinc.gumlet.io/pics/conventions/hawaii-retreat/retreat-hawaii-logo.png?w=700&dpr=2"
              className="w-full"
              id="title-logo"
              alt="The Retreat: Hawaii 2026"
            />

            <p className="mt-4 text-center">
              <span
                className="font-serif text-2xl text-white md:text-4xl"
                style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)' }}
              >
                31<sup>st</sup> Aug – 4<sup>th</sup> Sep 2026
                <br />
                Kauai, Hawaii
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
